<template>
  <div class="group-buy-home">
    <!-- 头部 -->
    <header class="header">
      <h1>省钱团</h1>
      <p class="subtitle">发现好物，一起团购</p>
    </header>

    <!-- 搜索栏 -->
    <div class="search-bar">
      <input type="text" placeholder="搜索团购商品..." v-model="searchKeyword" />
    </div>

    <!-- 分类标签 -->
    <div class="category-tabs">
      <div
        v-for="category in categories"
        :key="category.id"
        class="category-tab"
        :class="{ active: selectedCategory === category.id }"
        @click="selectedCategory = category.id"
      >
        {{ category.name }}
      </div>
    </div>

    <!-- 团购列表 -->
    <div class="group-list">
      <div
        v-for="item in filteredGroups"
        :key="item.id"
        class="group-card"
        @click="goToDetail(item.id)"
      >
        <div class="card-image">
          <img :src="item.image" :alt="item.title" />
          <span class="status-tag" :class="item.status">{{ item.statusText }}</span>
        </div>
        <div class="card-content">
          <h3 class="card-title">{{ item.title }}</h3>
          <p class="card-desc">{{ item.description }}</p>
          <div class="price-row">
            <span class="current-price">¥{{ item.currentPrice }}</span>
            <span class="original-price">¥{{ item.originalPrice }}</span>
          </div>
          <div class="progress-bar">
            <div class="progress" :style="{ width: item.progress + '%' }"></div>
          </div>
          <div class="progress-text">
            <span>已参团 {{ item.joinedCount }}/{{ item.targetCount }}</span>
            <span>{{ item.timeLeft }}</span>
          </div>
          <div class="merchant-info">
            <img :src="item.merchantAvatar" class="avatar" />
            <span class="merchant-name">{{ item.merchantName }}</span>
            <button class="call-merchant-btn" @click.stop="callMerchant(item)">
              📞 联系商家
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部导航 -->
    <GroupBuyNav />
  </div>
</template>

<script>
import GroupBuyNav from '@/components/GroupBuyNav.vue';

export default {
  name: 'GroupBuyHome',
  components: {
    GroupBuyNav
  },
  data() {
    return {
      searchKeyword: '',
      selectedCategory: 0,
      categories: [
        { id: 0, name: '全部' },
        { id: 1, name: '美食' },
        { id: 2, name: '生鲜' },
        { id: 3, name: '家居' },
        { id: 4, name: '美妆' },
        { id: 5, name: '服饰' }
      ],
      groups: [
        {
          id: 1,
          title: '新鲜草莓 现摘现发 5斤装',
          description: '产地直供，新鲜直达，坏果包赔',
          image: 'https://images.unsplash.com/photo-1464965911861-746a04b4bca6?w=300&h=200&fit=crop',
          currentPrice: 39.9,
          originalPrice: 68.0,
          joinedCount: 156,
          targetCount: 200,
          progress: 78,
          timeLeft: '还剩2天',
          status: 'ongoing',
          statusText: '进行中',
          merchantName: '鲜果优选',
          merchantAvatar: 'https://i.pravatar.cc/40?img=1',
          merchantPhone: '13800138001'
        },
        {
          id: 2,
          title: '进口车厘子 JJ级 2斤装',
          description: '智利进口，个大味甜，顺丰包邮',
          image: 'https://images.unsplash.com/photo-1528821128474-27f963b062bf?w=300&h=200&fit=crop',
          currentPrice: 89.9,
          originalPrice: 158.0,
          joinedCount: 89,
          targetCount: 100,
          progress: 89,
          timeLeft: '还剩1天',
          status: 'ongoing',
          statusText: '进行中',
          merchantName: '环球水果',
          merchantAvatar: 'https://i.pravatar.cc/40?img=2',
          merchantPhone: '13800138002'
        },
        {
          id: 3,
          title: '有机蔬菜礼盒 时令搭配',
          description: '当日采摘，绿色有机，健康之选',
          image: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=300&h=200&fit=crop',
          currentPrice: 49.9,
          originalPrice: 88.0,
          joinedCount: 200,
          targetCount: 200,
          progress: 100,
          timeLeft: '已成团',
          status: 'completed',
          statusText: '已成团',
          merchantName: '绿色农场',
          merchantAvatar: 'https://i.pravatar.cc/40?img=3',
          merchantPhone: '13800138003'
        },
        {
          id: 4,
          title: '网红零食大礼包 30包组合',
          description: '精选爆款，满足味蕾，办公室必备',
          image: 'https://images.unsplash.com/photo-1599490659213-e2b9527bd087?w=300&h=200&fit=crop',
          currentPrice: 59.9,
          originalPrice: 99.0,
          joinedCount: 45,
          targetCount: 150,
          progress: 30,
          timeLeft: '还剩3天',
          status: 'ongoing',
          statusText: '进行中',
          merchantName: '零食铺子',
          merchantAvatar: 'https://i.pravatar.cc/40?img=4',
          merchantPhone: '13800138004'
        },
        {
          id: 5,
          title: '纯棉四件套 简约北欧风',
          description: '亲肤柔软，舒适睡眠，多色可选',
          image: 'https://images.unsplash.com/photo-1629026707321-c4d68249dd66?w=300&h=200&fit=crop',
          currentPrice: 129.0,
          originalPrice: 299.0,
          joinedCount: 67,
          targetCount: 100,
          progress: 67,
          timeLeft: '还剩5天',
          status: 'ongoing',
          statusText: '进行中',
          merchantName: '家纺优选',
          merchantAvatar: 'https://i.pravatar.cc/40?img=5',
          merchantPhone: '13800138005'
        }
      ]
    };
  },
  computed: {
    filteredGroups() {
      let result = this.groups;
      if (this.selectedCategory > 0) {
        // 简单模拟分类过滤
        result = this.groups.filter((_, index) => index % 5 === this.selectedCategory - 1);
      }
      if (this.searchKeyword) {
        result = result.filter(item =>
          item.title.includes(this.searchKeyword) ||
          item.description.includes(this.searchKeyword)
        );
      }
      return result;
    }
  },
  methods: {
    goToDetail(id) {
      this.$router.push({ name: 'GroupBuyDetail', params: { id } });
    },
    callMerchant(item) {
      window.location.href = `tel:${item.merchantPhone}`;
    }
  }
};
</script>

<style scoped>
.group-buy-home {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 70px;
}

.header {
  background: linear-gradient(135deg, #ff6b6b, #ee5a6f);
  color: white;
  padding: 20px;
  text-align: center;
}

.header h1 {
  margin: 0;
  font-size: 24px;
}

.subtitle {
  margin: 5px 0 0;
  font-size: 14px;
  opacity: 0.9;
}

.search-bar {
  padding: 15px;
  background: white;
}

.search-bar input {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  font-size: 14px;
  outline: none;
}

.category-tabs {
  display: flex;
  overflow-x: auto;
  padding: 10px 15px;
  background: white;
  gap: 10px;
}

.category-tab {
  padding: 8px 16px;
  border-radius: 20px;
  background: #f0f0f0;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s;
}

.category-tab.active {
  background: #ff6b6b;
  color: white;
}

.group-list {
  padding: 15px;
}

.group-card {
  background: white;
  border-radius: 12px;
  margin-bottom: 15px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.2s;
}

.group-card:hover {
  transform: translateY(-2px);
}

.card-image {
  position: relative;
  height: 180px;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.status-tag {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  color: white;
}

.status-tag.ongoing {
  background: #ff6b6b;
}

.status-tag.completed {
  background: #52c41a;
}

.card-content {
  padding: 15px;
}

.card-title {
  margin: 0 0 8px;
  font-size: 16px;
  color: #333;
}

.card-desc {
  margin: 0 0 10px;
  font-size: 13px;
  color: #999;
}

.price-row {
  margin-bottom: 10px;
}

.current-price {
  font-size: 22px;
  font-weight: bold;
  color: #ff6b6b;
  margin-right: 10px;
}

.original-price {
  font-size: 14px;
  color: #999;
  text-decoration: line-through;
}

.progress-bar {
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress {
  height: 100%;
  background: linear-gradient(90deg, #ff6b6b, #ee5a6f);
  border-radius: 3px;
  transition: width 0.3s;
}

.progress-text {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #666;
  margin-bottom: 10px;
}

.merchant-info {
  display: flex;
  align-items: center;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 8px;
}

.merchant-name {
  flex: 1;
  font-size: 13px;
  color: #666;
}

.call-merchant-btn {
  padding: 6px 12px;
  background: #fff0f0;
  border: 1px solid #ff6b6b;
  border-radius: 15px;
  color: #ff6b6b;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.call-merchant-btn:hover {
  background: #ff6b6b;
  color: white;
}
</style>
